import { COLOR_GREEN_600, COLOR_GREEN_700 } from '@alltrails/denali/tokens';
import { createDefaultParkPinSvg } from './svgMarkerComponents';

const defaultParkPinSvg = createDefaultParkPinSvg('default-park-pin', COLOR_GREEN_600);
const activeDefaultParkPinSvg = createDefaultParkPinSvg('active-default-park-pin', COLOR_GREEN_700);

export { defaultParkPinSvg, activeDefaultParkPinSvg };
